export const REGEX_UPPERCASE_AND_LOWERCASE = /[A-Za-z]/;
export const REGEX_DIGIT = /[0-9]/;
export const REGEX_SPECIAL_CHARACTER = /[^a-zA-Z\d\s]/;
export const REGEX_PHONE = /^\(?\d{2}\)?[\s-]?\d{4,5}-?\d{4}$/;
export const REGEX_SOLUTION_TITLE = /^[A-Za-zÀ-ÖØ-öø-ÿÇç0-9\s]+$/;
